<template>
  <ion-card>
    <img :src="logoSrc" />
    <ion-card-header>
      <p>
        Please enter the <b>One Time Passcode (OTP)</b> you received via text or
        email.
      </p>
    </ion-card-header>

    <ion-card-content>
      <div class="input-container">
        <ion-label color="light">Passcode</ion-label>
        <ion-item
          color="light"
          lines="none"
          :class="{ 'ion-invalid': !isValid }"
        >
          <ion-input v-model="passcode"></ion-input>
          <ion-note slot="error">{{ errorMessagePasscode }}</ion-note>
        </ion-item>
      </div>
      <ion-button
        id="submit-btn"
        @click="submit()"
        :class="{
          'button-full-width': isMobile,
          'button-partial-width': !isMobile,
        }"
        :style="{ '--background': branding.color_primary }"
      >
        <span v-if="!isLoading">Submit</span>
        <ion-spinner v-if="isLoading"></ion-spinner>
      </ion-button>
    </ion-card-content>
  </ion-card>
</template>

<script setup>
import {
  IonCard,
  IonCardHeader,
  IonCardContent,
  IonItem,
  IonLabel,
  IonInput,
  IonNote,
  IonButton,
  IonSpinner,
} from '@ionic/vue';
import { ref, onMounted, onUnmounted, computed } from 'vue';
import { useRouter } from 'vue-router';
import { useCustomerStore } from '../store/customer';
import { useBrandingStore } from '../store/branding';
import * as Sentry from '@sentry/vue';

const router = useRouter();
const customerStore = useCustomerStore();
const brandingStore = useBrandingStore();
const logoSrc = ref('');
const passcode = ref('');
const isValid = ref(true);
const errorMessagePasscode = ref('');
const isLoading = ref(false);
const screenWidth = ref(window.innerWidth);
const isMobile = computed(() => {
  return screenWidth.value < 768;
});
const handleResize = () => {
  screenWidth.value = window.innerWidth;
};
const branding = brandingStore.brandCSS;
logoSrc.value = brandingStore.brand.logo_footer;

async function submit() {
  isLoading.value = true;

  if (!passcode.value) {
    isValid.value = false;
    errorMessagePasscode.value = 'Please enter your passcode';
    isLoading.value = false;
    return;
  }

  try {
    const customer = await customerStore.fetchCustomer(passcode.value);

    if (customer.data.success) {
      isValid.value = true;
      router.push({ name: 'dashboard' });
    }
  } catch (error) {
    isValid.value = false;
    errorMessagePasscode.value = error.message;
    Sentry.captureException(error);
  } finally {
    isLoading.value = false;
  }
}

onMounted(() => {
  window.addEventListener('resize', handleResize);
});

onUnmounted(() => {
  window.removeEventListener('resize', handleResize);
});
</script>

<style lang="scss" scoped>
ion-card {
  width: 100%;
  max-width: 500px;
  box-shadow: none;
  text-align: center;

  img {
    max-width: 60%;
  }

  ion-card-subtitle {
    padding: 10px;
  }

  .input-container {
    text-align: start;
  }

  ion-label {
    margin-left: 8px;
  }

  ion-item {
    padding: 10px;
  }

  p {
    color: #ffffff;
  }
}

@media (max-width: 768px) {
  .button-full-width {
    width: 94%;
  }
}

@media (min-width: 769px) {
  .button-partial-width {
    width: 42%;
  }
}
</style>
